import { Loader2 } from "lucide-react";
import { TEMPLATES, SelectField } from "./shared";

export default function MessagingTab({ ctx }) {
  const {
    msgForm, setMsgForm, divisions, sendResult, recipientCount,
    sendMessage, sending, messages,
  } = ctx;
  return (
    <>
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-white">Messaging Center</h1>
      <div className="mt-8 grid grid-cols-1 lg:grid-cols-5 gap-8">
        <div className="lg:col-span-3 rounded-2xl bg-white/5 border border-white/10 p-6 md:p-8">
          <p className="text-sm font-bold uppercase tracking-wider text-white/40">Audience</p>
          <div className="mt-3 flex flex-wrap gap-2">
            {[["all_members", "All Members"], ["division", "By Division"], ["waitlist", "Waitlist"], ["canceled", "Canceled"]].map(([val, label]) => (
              <button key={val} data-testid={`msg-segment-${val}`} onClick={() => setMsgForm({ ...msgForm, segment: val })}
                className={`rounded-full px-4 py-2 text-sm font-bold border-2 transition-colors ${msgForm.segment === val ? "border-[#2563EB] bg-[#2563EB] text-white" : "border-white/15 text-white/60 hover:text-white"}`}>
                {label}
              </button>
            ))}
          </div>

          {msgForm.segment === "division" && (
            <div className="mt-4">
              <SelectField label="Division" testid="msg-division" value={msgForm.division_id} onChange={(v) => setMsgForm({ ...msgForm, division_id: v })}
                options={divisions.filter((d) => d.status === "active").map((d) => [d.id, d.name])} />
            </div>
          )}

          <p className="mt-6 text-sm font-bold uppercase tracking-wider text-white/40">Template</p>
          <select data-testid="msg-template" onChange={(e) => { const t = TEMPLATES[e.target.value]; if (t) setMsgForm({ ...msgForm, subject: t.subject, body: t.body }); }}
            className="mt-2 w-full bg-white/5 border border-white/10 rounded-2xl px-4 py-3 text-white outline-none focus:border-[#2563EB]">
            <option value="">Start from scratch…</option>
            {TEMPLATES.map((t, i) => <option key={t.name} value={i}>{t.name}</option>)}
          </select>

          <div className="mt-5">
            <input data-testid="msg-subject" value={msgForm.subject} onChange={(e) => setMsgForm({ ...msgForm, subject: e.target.value })} placeholder="Subject"
              className="w-full bg-white/5 border border-white/10 rounded-2xl px-5 py-4 text-white placeholder-white/30 outline-none focus:border-[#2563EB]" />
            <textarea data-testid="msg-body" value={msgForm.body} onChange={(e) => setMsgForm({ ...msgForm, body: e.target.value })} rows={9} placeholder="Write your message…"
              className="mt-3 w-full bg-white/5 border border-white/10 rounded-2xl px-5 py-4 text-white placeholder-white/30 outline-none focus:border-[#2563EB] resize-none" />
            <p className="mt-2 text-xs font-medium text-white/40">Personalize with {"{{player_name}}"}, {"{{parent_name}}"}, {"{{division}}"}.</p>
          </div>

          {sendResult && <p data-testid="msg-result" className="mt-4 text-sm font-semibold text-emerald-300">Sent to {sendResult.sent} of {sendResult.recipients} recipients{sendResult.failed ? ` (${sendResult.failed} failed)` : ""}.</p>}

          <div className="mt-6 flex items-center justify-between gap-4">
            <p data-testid="msg-recipient-count" className="text-sm font-bold text-white/60">{recipientCount} recipient{recipientCount === 1 ? "" : "s"}</p>
            <button data-testid="msg-send-btn" onClick={sendMessage} disabled={sending || !msgForm.subject.trim() || !msgForm.body.trim() || recipientCount === 0}
              className="inline-flex items-center gap-2 bg-[#2563EB] hover:bg-[#1d4fd7] disabled:opacity-50 text-white font-bold px-7 py-3.5 rounded-full transition-colors">
              {sending ? <><Loader2 size={18} className="animate-spin" /> Sending…</> : `Send to ${recipientCount}`}
            </button>
          </div>
        </div>

        <div className="lg:col-span-2">
          <p className="text-sm font-bold uppercase tracking-wider text-white/40">Recent Sends</p>
          <div className="mt-3 space-y-3">
            {messages.length === 0 && <p className="text-white/40 font-medium text-sm">No messages sent yet.</p>}
            {messages.map((m) => (
              <div key={m.id} data-testid={`message-${m.id}`} className="rounded-2xl bg-white/5 border border-white/10 p-4">
                <p className="text-sm font-bold text-white">{m.subject}</p>
                <p className="mt-1 text-xs font-medium text-white/40">{m.segment.replace("_", " ")} · {m.sent}/{m.recipients} sent · {(m.created_at || "").slice(0, 10)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
